module.exports = __webpack_public_path__ + "static/media/address1.606455f0.svg";